export enum AgreementServiceType {
	abonent = 1,
	complex = 3,
}
